import React from "react";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const createTimeLogBulkAttendance = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CreateBulkAttendance,
    input
  );
  return data;
};

export const useCreateTimeLogBulkMutation = () => {
  return useMutation({
    mutationFn: createTimeLogBulkAttendance,
  });
};

const updateTimeLogBulkAttendance = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.UpdateBulkAttendance,
    input
  );
  return data;
};

export const useUpdateTimeLogBulkMutation = () => {
  return useMutation({
    mutationFn: updateTimeLogBulkAttendance,
  });
};
